import { Button } from "@faire/slate/components/button";
import { TextInput } from "@faire/slate/components/text-input";
import { useState } from "react";

import { LEGAL_BUSINESS_NAME_COPY, RETAILER_STORE_NAME } from "./data";
import { SignupStepHeader } from "./shared";

export interface LegalBusinessNameStepMockProps {
  onContinue: () => void;
  isSubmitting: boolean;
}

/**
 * Recreation of the real LEGAL_BUSINESS_NAME step — this is the step
 * immediately before the wait we're redesigning, so the flow below starts
 * here and shows the full handoff into the transition and reveal.
 */
export const LegalBusinessNameStepMock: React.FC<
  LegalBusinessNameStepMockProps
> = ({ onContinue, isSubmitting }) => {
  const [businessName, setBusinessName] = useState(RETAILER_STORE_NAME);

  const handleSubmit = (event: React.FormEvent): void => {
    event.preventDefault();
    onContinue();
  };

  return (
    <div className="bg-fs-surface-primary flex min-h-full w-full flex-col">
      <SignupStepHeader progressPercent={78} />
      <form
        onSubmit={handleSubmit}
        className="mx-auto flex w-full max-w-[480px] flex-1 flex-col gap-(--slate-dimensions-8) px-(--slate-dimensions-6) py-(--slate-dimensions-10)"
      >
        <div className="flex flex-col gap-(--slate-dimensions-3)">
          <h1 className="type-fs-display-s text-fs-text-primary">
            {LEGAL_BUSINESS_NAME_COPY.title}
          </h1>
          <p className="type-fs-paragraph text-fs-text-subdued">
            {LEGAL_BUSINESS_NAME_COPY.subtitle}
          </p>
        </div>
        <TextInput
          label={LEGAL_BUSINESS_NAME_COPY.fieldLabel}
          value={businessName}
          onChange={(event) => setBusinessName(event.target.value)}
        />
        <div className="mt-auto flex flex-col pt-(--slate-dimensions-10)">
          <Button
            type="submit"
            variant="primary"
            loading={isSubmitting}
            data-test-id="legal-business-name-cta"
          >
            {LEGAL_BUSINESS_NAME_COPY.ctaLabel}
          </Button>
        </div>
      </form>
    </div>
  );
};
